import { render, staticRenderFns } from "./SlideBar.vue?vue&type=template&id=61447717&"
import script from "./SlideBar.vue?vue&type=script&lang=js&"
export * from "./SlideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports